module.exports = __webpack_public_path__ + "static/media/icon_starred_seet_summary.9c2eda54.svg";